import React, { useState } from "react";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useMDSData(summaryData, prefix) {
  const [mdsData, setMdsData] = useState([])
  const [mdsDataReady, setMdsDataReady] = useState(true)
  const [mdsMeterData, setMdsMeterData] = useState([])
  const [customMDSPostcode, setCustomMDSPostcode] = useState('')

  const getMDSData = () => {
    if (!summaryData || !summaryData.Core_SPID) return
    setMdsDataReady(false);
    request(true).get(endpoints[`${prefix}_MDS_SPID`], {
      doesCancel: true,
      params: {
        postcode: customMDSPostcode || summaryData.CF_Postcode || summaryData.CMOS_Postcode,
        cmos_uprn: summaryData.CMOS_UPRN,
        cmos_voa_no: summaryData.CMOS_VOA,
      }
    }).then(r => {
      setMdsData(r.data)
      setMdsDataReady(true)
    }).catch(e => {
      setMdsDataReady(true)
      console.log(e);
    })
    request(true).get(endpoints[`${prefix}_MDS_METER`], {
      params: {
        w_spid: summaryData.W_SPID,
        s_spid: summaryData.S_SPID
      }
    }).then(r => {
      setMdsMeterData(r.data);
    }).catch(e => {
      console.log(e);
    })
  }

  return { mdsData, setMdsData, mdsDataReady, setMdsDataReady, mdsMeterData, setMdsMeterData, customMDSPostcode, setCustomMDSPostcode, getMDSData }
}
